




































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import AppDialog from '@/components/AppDialog.vue'
import FoldingCard from '@/components/FoldingCard.vue'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'
import { formatPhoneNumber } from '@/utils/phoneNumberFormat'
import { ThirdParty } from '@/modules/ThirdParty/interfaces/third-party'

@Component({
  components: {
    FoldingCard,
    AppDialog,
    AppSystemInfoCard
  }
})
export default class ThirdPartyDetailDetail extends Vue {
  @Prop({ type: Object as () => ThirdParty }) readonly thirdParty!: ThirdParty

  formatPhoneNumber = formatPhoneNumber

  get notes () {
    if (!this.thirdParty || !this.thirdParty.notes) return ['-']
    return this.thirdParty.notes.split('\n')
  }
}
